var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.products),function(product){return _c('li',{key:product.key,class:_vm.options.background},[_c('cart-product',{attrs:{"product":product}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }